










































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import teamEngagementProgress from "./teamEngagementProgress.vue";
import teamEngagementLabels from "./teamEngagementLabels.vue";
import { spaceUppercases, percentFromTotal, roundPercentage } from "../../utils";
import { Getter, Action } from "vuex-class";
import { Team, TeamEngagement } from "../../types";

@Component({
  components: {
    teamEngagementProgress,
    teamEngagementLabels
  }
})
export default class TeamEngagementChart extends Vue {
  
  @Action private fetchTeamEngagement!: (id: Number) => any;
  @Getter private currentTeamID?: number;
  @Getter private teamEngagement!: any;

  private total: number = 0;
  private labels: string[] = [];
  private engagementData: number[] = [];
  private percentageData: number[] = [];
  private engagementUserNamesKey: string[] = [];
  private engagementUserNames: Map<string, string> = new Map<string, string>();
  private datacollection: any = null;
  private colors: string[] = ["#38D17A", "#FFCC00", "#F74657"];
  private detailsModalShow: boolean = false;
  private selectedModalTabPosition: number = 0;
  private isShowTooltip = false
  private tooltip = "Active: used the app in the last week Rare: used the app in the last 2 weeks Absent: haven’t used the app in the last 2 weeks"

  private created() {
    if(this.teamEngagement!=null)
      this.teamEngagementData()
    
    this.fetchData()
  }

  @Watch("currentTeamID")
  private onCurrentTeamIdChanged(newVal: string, oldVal: string) {
    if (newVal && newVal !== oldVal) {
      this.fetchData()   
    }
  }

  private fetchData() {
    this.fetchTeamEngagement(this.currentTeamID!)
  }

  private percentFromTotal = percentFromTotal;
  private roundPercentage = roundPercentage;

   openModal(selectedTab: number) {
    this.detailsModalShow = true
    this.selectedModalTabPosition = selectedTab;
  } 
  
  onChangeModalTab(selectedTab: number) {
    this.selectedModalTabPosition = selectedTab;
  }
  
  onModalShow() {
    document.documentElement.style.overflow = 'hidden'
  }

  onModalHidden() {
    document.documentElement.style.overflow = 'auto'
    this.detailsModalShow = false
  }

  @Watch("teamEngagement")
  private teamEngagementData() {

    if (Object.keys(this.teamEngagement).length) {
      
      let engagementData = [];
      let engagementUserNames = new Map<string, string>()
      let labels = [];
      let engagementUserNamesKey = [];
      let total = 0;

      for (let key in this.teamEngagement) {
        let val = this.teamEngagement[key];
        if(typeof val === 'number') {
          engagementData.push(val);
          labels.push(spaceUppercases(key));
          total += val;
        } else {
          engagementUserNamesKey.push(key)
          engagementUserNames.set(key, val)
        }
      }
      let percentageData = []
      for(let index in engagementData) {
        percentageData.push(percentFromTotal(engagementData[index],total))
      }
     
      this.percentageData = roundPercentage(percentageData)
      this.engagementData = engagementData;
      this.engagementUserNames = engagementUserNames;
      this.engagementUserNamesKey = engagementUserNamesKey;
      this.labels = labels;
      this.total = total;
      let colors = this.colors;

      // Handle empty state data
      if (total === 0) {
        this.engagementData = [100];
        colors = [];
      }

      this.datacollection = {
        labels: labels,
        datasets: [
          {
            data: this.engagementData,
            backgroundColor: colors,
            borderWidth: 0
          }
        ]
      };
    }
  }
}
